import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Lanes" hint="Lane stats — pricing anomaly flagging." /> }
